"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
var model_1 = require("../model");
var urlHelper_1 = require("../../utils/urlHelper");
var user_1 = require("../user");
var dataConverter_1 = require("../../utils/dataConverter");
var Entity = /** @class */ (function (_super) {
    __extends(Entity, _super);
    function Entity(data) {
        var _this = _super.call(this, __assign(__assign({}, data), { type: data['@type'] })) || this;
        if (data.owner) {
            _this.owner = new user_1.User(data.owner);
        }
        if (data.author) {
            _this.author = new user_1.User(data.author);
        }
        if (data.changeRequest) {
            _this.changeRequest = dataConverter_1.createEntityChangeRequestFromData(data.changeRequest);
        }
        return _this;
    }
    Entity.prototype.getImageSource = function (imageType) {
        var imageUrl = this.getImageUrl(imageType);
        var mtvaImageUrl = this.getMtvaImageUrl(imageType);
        if (!imageUrl && mtvaImageUrl) {
            return 'MTVA képtár';
        }
        if (!imageUrl || imageUrl === '') {
            return null;
        }
        var capitalizedImageType = imageType.charAt(0).toUpperCase() + imageType.slice(1);
        var fortepanImageKey = "fortepan" + capitalizedImageType + "ImageSource";
        var hasFortepanSource = this.hasOwnProperty(fortepanImageKey)
            && this[fortepanImageKey] && this[fortepanImageKey].length
            && this[fortepanImageKey] !== 'null';
        if (hasFortepanSource) {
            return this[fortepanImageKey];
        }
        var imageKey = imageType + "ImageSource";
        if (this.hasOwnProperty(imageKey) && this[imageKey] && this[imageKey].length) {
            return this[imageKey];
        }
        return null;
    };
    Entity.prototype.getImageUrl = function (imageType) {
        var key = imageType + "ImageUrl";
        if (!this.hasOwnProperty(key) || !this[key]) {
            return null;
        }
        return urlHelper_1.default.getUrl(this[key]);
    };
    Entity.prototype.getMtvaImageUrl = function (imageType, size) {
        if (size === void 0) { size = 'sm'; }
        var key = imageType + "MtvaImageUrl";
        if (!this.hasOwnProperty(key) || !this[key]) {
            return null;
        }
        return urlHelper_1.default.getMtvaUrl(this[key], size);
    };
    Entity.prototype.getMtvaImagePosition = function (imageType) {
        var key = imageType + "MtvaImagePosition";
        if (!this.hasOwnProperty(key) || !this[key]) {
            return null;
        }
        return this[key];
    };
    Entity.prototype.getDefaultImageUrl = function () {
        return urlHelper_1.default.getUrl(this.defaultImageUrl);
    };
    Entity.prototype.getCoverImageUrl = function () {
        return urlHelper_1.default.getUrl(this.coverImageUrl);
    };
    Entity.prototype.getWideImageUrl = function () {
        return urlHelper_1.default.getUrl(this.wideImageUrl);
    };
    Entity.prototype.getSquareImageUrl = function () {
        return urlHelper_1.default.getUrl(this.squareImageUrl);
    };
    Entity.prototype.getPortraitImageUrl = function () {
        return urlHelper_1.default.getUrl(this.portraitImageUrl);
    };
    Entity.prototype.getFileSizeInKB = function () {
        if (!this.fileSize) {
            return 0;
        }
        return Math.round(this.fileSize / 1024);
    };
    Entity.prototype.getFileSizeInMB = function () {
        if (!this.fileSize) {
            return 0;
        }
        return (this.fileSize / 1024 / 1024).toPrecision(2);
    };
    return Entity;
}(model_1.default));
exports.Entity = Entity;
